import { useTheme } from "@mui/material";
import { ApexOptions } from "apexcharts";
import Chart from "react-apexcharts";
import { useNavigate } from "react-router-dom";

type PieChartProps = {
  options: ApexOptions;
  data:
    | number[]
    | { name: string; data: number[] }[]
    | { name: string; data: { x: string; y: number[] | number }[] }[];
  labels: string[];
  type: "donut" | "bar" | "line" | "pie" | "rangeBar" | "radar" | "heatmap";
  stacked?: boolean;
  onClick: () => void;
  onLegendClick?: (series: number[]) => void;
  width?: string;
  id?: string;
  height?: string;
  noData?: ApexNoData;
};

const PieChart = (props: PieChartProps) => {
  const {
    options,
    data,
    labels,
    type,
    stacked = false,
    onClick,
    width,
    onLegendClick,
    id,
    height = "100%",
    noData,
  } = props;
  const navigate = useNavigate();
  const theme = useTheme();
  return (
    <Chart
      options={{
        ...options,
        chart: {
          id: id,
          toolbar: {
            show: false,
          },
          events: {
            dataPointSelection: async (event: any, charContext: any, config: any) => onClick(),
            click: async (event: any, chartContext: any, config: any) =>
              type === "line" && onClick(),
            legendClick: async (event: any, chartContext: any, config: any) => {
              type === "line" &&
                (await config) &&
                onLegendClick &&
                onLegendClick(config.globals.collapsedSeriesIndices ?? []);
            },
          },
          zoom: {
            enabled: false, // Disable zooming
          },
          stacked: stacked,
          redrawOnParentResize: true,
          redrawOnWindowResize: true,
        },
        noData: noData ?? {
          text: "No data",
          style: {
            fontSize: "14px",
            fontFamily: "'Inter', sans-serif",
            color: theme.palette.custom.grey[600],
          },
        },
      }}
      series={data}
      type={type}
      width={width ? width : type === "bar" ? "400" : "380"}
      height={height}
    />
  );
};

export { PieChart };
